<template>
  <vx-card no-shadow>

    <vs-table
      stripe
      max-items="50"
      no-data-text="Loading Categories..."
      pagination
      :data="categoryListFiltered"
      v-model="selectedCategory"
      @selected="HandleSelectedCategory"
    >
      <template slot="header">
        <div class="category-table-header">
          <vs-input label="Search" v-model="categorySearch" class="mb-2 category-search"></vs-input>
          <div class="spacer"></div>
          <div class="ml-3">
            <vs-button @click="BeginCreateCategory" class="mb-2" icon-pack="feather" icon="icon-plus" >New</vs-button>
          </div>
        </div>
      </template>
      <template slot="thead">
        <vs-th>ID</vs-th>
        <vs-th sort-key="CategoryName">
          Category Name
        </vs-th>
        <vs-th sort-key="ClientName">
          Client
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ tr.CategoryID }}</vs-td>
          <vs-td>
            {{ tr.CategoryName }}
          </vs-td>
          <vs-td>
            {{ GetClientName(tr.ClientID) }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-prompt
      :title="selectedCategory == null ? 'Create Category' : 'Edit Category'"
      :active.sync="categoryModalOpen"
      :buttons-hidden="true"
    >
      <div style="height: 300px;">
        <v-select :options="clientList" :reduce="x => x.ClientID" label="ClientName" v-model="categoryEditing.ClientID" placeholder="Client" />
          
        <vs-input label="Category Name" v-model="categoryEditing.CategoryName" class="mt-4"></vs-input>

      </div>

      <div class="modal-footer">
        <vs-button v-if="selectedCategory != null" :disabled="deletingCategory || savingCategory" @click="DeleteCategory" color="danger">Delete</vs-button>
        <vs-button :disabled="savingCategory || !canSaveCategory || deletingCategory" @click="SaveCategory()" class="ml-2 mt-2">Save</vs-button>
      </div>
    </vs-prompt>


  </vx-card>
</template>

<script>

import axios from '../../axios.js'
import Vue from 'vue'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
      selectedCategory: null,
      categoryModalOpen: false,
      categoryEditing: {},
      categorySearch: '',
      savingCategory: false,
      deletingCategory: false,
    }
  },
  computed: {
    categoryList() {
      return this.$store.getters.GetCategoryList.map(x => {
        return {
          ...x,
          ClientName: this.GetClientName(x.ClientID)
        }
      })
    },
    categoryListFiltered() {
      return this.categoryList.filter(x => x.CategoryName.toLowerCase().indexOf(this.categorySearch.toLowerCase()) != -1 || x.ClientName.toLowerCase().indexOf(this.categorySearch.toLocaleLowerCase()) != -1)
    },
    clientList() {
      return this.$store.getters.GetClientList
    },
    canSaveCategory() {
      if (this.categoryEditing.CategoryName == null) return false
      if (this.categoryEditing.CategoryName.length < 2) return false

      if (this.categoryEditing.ClientID == null) return false
      return true
    }
  },
  methods:{
   HandleSelectedCategory() {
    this.categoryModalOpen = true
    this.categoryEditing = JSON.parse(JSON.stringify(this.selectedCategory))
   },
   async SaveCategory() {
    this.savingCategory = true
    try { 
      await this.$store.dispatch('ActionSaveCategory', this.categoryEditing)
      await this.$store.dispatch('ActionFetchCategories')
    } catch (e) { }
    this.savingCategory = false
    this.categoryModalOpen = false
   },
   async DeleteCategory() {
    this.deletingCategory = true
    try {
      await this.$store.dispatch('ActionDeleteCategory', this.categoryEditing.CategoryID)
    } catch (e) {}
    this.deletingCategory = false
    this.categoryModalOpen = false
   },
   GetClientName(id) {
    try {
      const c = this.clientList.find(x => x.ClientID == id)
      return c ? c.ClientName : ''
    } catch (e) {

    }
    return '   '
   },
   BeginCreateCategory() {
    this.categoryEditing = {}
    this.selectedCategory = null
    this.categoryModalOpen = true
   }
  }
}
</script>

<style scoped>
.category-table-header {
  display: flex;
  flex-grow: 1;
  align-items: end;
}

.category-search {
  max-width: 400px;
}
.spacer {
  flex-grow: 1;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>